import {BaseConverter} from '../../base/converters/base-converter.converter';
import {DomainModel} from '../models/domain.model';
import {Domain} from '../DTO/domain';

export class DomainConverter extends BaseConverter<DomainModel, Domain> {
  convertToDto(model: DomainModel): Domain {
    if (!model) {
      return undefined;
    }
    return {
      certificationDate: model.certificationDate,
      certificationState: model.certificationState,
      dnsConfigurationState: model.dnsConfigurationState,
      external: model.external,
      lastCheckDate: model.lastCheckDate,
      name: model.name,
      serverConfigurationState: model.serverConfigurationState
    };
  }

  convertToModel(dto: Domain): DomainModel {
    if (!dto) {
      return null;
    }
    let model: DomainModel = new DomainModel();

    model.certificationDate = dto.certificationDate;
    model.certificationState = dto.certificationState;
    model.dnsConfigurationState = dto.dnsConfigurationState;
    model.external = dto.external;
    model.lastCheckDate = dto.lastCheckDate;
    model.name = dto.name;
    model.serverConfigurationState = dto.serverConfigurationState;
    return model;
  }

}
